"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsUserRoleLoadingSelector = exports.isUserRoleLoading = exports.useUserRoleSelector = exports.userRoleSelector = void 0;
const react_redux_1 = require("react-redux");
const reselect_1 = require("reselect");
const main_1 = require("./main");
exports.userRoleSelector = (0, reselect_1.createSelector)(main_1.enrichSelector, ({ user }) => user.role);
const useUserRoleSelector = () => (0, react_redux_1.useSelector)(exports.userRoleSelector);
exports.useUserRoleSelector = useUserRoleSelector;
exports.isUserRoleLoading = (0, reselect_1.createSelector)(main_1.enrichSelector, ({ user }) => user.isRoleLoading);
const useIsUserRoleLoadingSelector = () => (0, react_redux_1.useSelector)(exports.isUserRoleLoading);
exports.useIsUserRoleLoadingSelector = useIsUserRoleLoadingSelector;
